import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import VueYoutube from 'vue-youtube'
import VueMeta from 'vue-meta'
import App from './App'
import * as firebase from 'firebase'
import router from './router'
import vuetify from './plugins/vuetify'
import { store } from './store'
import DateFilter from './filters/date'
import AlertCmp from './components/Shared/Alert.vue'
import EditMeetupDetailsDialog from './components/Meetup/Edit/EditMeetupDetailsDialog.vue'
import RegisterDialog from './components/Meetup/Registration/RegisterDialog.vue'
import HeaderBlock from './components/HeaderBlock.vue'
import ModalRules from './components/Modals/ModalRules.vue'
import ModalContact from './components/Modals/ModalContact.vue'
import ModalVideo from './components/Modals/ModalVideo.vue'
import ModalAuth from './components/Modals/ModalAuth.vue'



Vue.use(VueCarousel)
Vue.use(VueYoutube)
Vue.use(VueMeta)
Vue.config.productionTip = false


Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertCmp)
Vue.component('app-edit-meetup-details-dialog', EditMeetupDetailsDialog)
Vue.component('app-meetup-register-dialog', RegisterDialog)
Vue.component('app-header-block', HeaderBlock)
Vue.component('app-modal-rules', ModalRules)
Vue.component('app-modal-contact', ModalContact)
Vue.component('app-modal-video', ModalVideo)
Vue.component('app-modal-auth', ModalAuth)


new Vue({
  el: "#app",
  router,
  store,
  vuetify,
  components: { App },
  template: "<App/>",
  created() {
    firebase.initializeApp({
      apiKey: "AIzaSyDGAu14JBup-tF0X25-8BWIdr82_oPx57k",
      authDomain: "steelhit-dc995.firebaseapp.com",
      databaseURL: "https://steelhit-dc995.firebaseio.com",
      projectId: "steelhit-dc995",
      storageBucket: "steelhit-dc995.appspot.com",
      messagingSenderId: "08912682498",
      appId: "1:608912682498:web:7b8870f4d54d2c8a05811b"
    })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
        this.$store.dispatch('fetchUserData')
      }
    })
    this.$store.dispatch('loadMeetups')

    }
})



// WEBPACK FOOTER //
// ./src/main.js